import Vue from 'vue'
import ShareGuide from './index.vue'
import { Message } from 'element-ui'
const Constructor = Vue.extend(ShareGuide)
// 是否微信环境
function isWechat() {
    const ua = navigator.userAgent.toLowerCase()
    return ua.indexOf('micromessenger') !== -1
}
let instance = null
// 复制文本
async function copyText(text) {
    // 优先 Clipboard API
    if (navigator.clipboard && window.isSecureContext) {
        await navigator.clipboard.writeText(text)
        return
    }

    // 兼容 http 或旧浏览器
    const input = document.createElement('textarea')
    input.value = text
    input.style.position = 'fixed'
    input.style.opacity = '0'
    document.body.appendChild(input)
    input.select()

    document.execCommand('copy')

    document.body.removeChild(input)
}
export default {

    async show() {
        // 微信内
        if (isWechat()) {
            if (!instance) {
                instance = new Constructor()

                instance.$mount()

                document.body.appendChild(instance.$el)
            }

            instance.show()
            return
        }

        // 非微信
        try {
            await copyText(window.location.href)
            Message.success('链接已复制，请发送给好友')
        } catch (e) {
            Message.error('复制失败，请手动复制链接')
        }
    },


    hide() {
        if (instance) {
            instance.hide()
        }
    }
}